import { Box } from "rebass/styled-components";
import { position, compose, border, display, system } from "styled-system";
import styled from "styled-components";

const BoxUpgraded = styled(Box)`
  ${compose(position, border, display, system({ cursor: true }))}
`;

export default BoxUpgraded;
